module.exports = __webpack_public_path__ + "img/seacloud.png";